import React, { PropsWithChildren, useState } from "react";
import { useDirectoryContext } from "../../Context/DirectoryContext";

import { Button } from "../../../shared/Button/Button";
import { Icon } from "../../../shared/Icon/Icon";
import { ReAuthModal } from "../../../Modals/ReAuthModal/ReAuthModal";

export const DirectoryIntegrationError = ({
  id,
  message,
}: PropsWithChildren<{ id: string; message: string }>) => {
  const [openReAuthModal, setOpenReAuthModal] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const { handleFixDirectoryButton } = useDirectoryContext();

  return (
    <>
      {openReAuthModal && (
        <ReAuthModal
          closeModal={() => setOpenReAuthModal(false)}
          handleReAuthButton={() => handleFixDirectoryButton(id)}
          type="Directory"
        />
      )}
      <div className="CalendarError d-flex mt-3">
        <div className="d-flex gap-1">
          <Icon icon="red-error-icon" />

          <div className="d-flex flex-column CalendarError__content">
            <span>
              Auto-renewal of renew-token failed. Directory integration
              re-authentication is required.
            </span>
            <span className="CalendarError__content--provider">
              <span>Message from directory provider:</span>
              <span className="CalendarError__content--provider--message">
                {isExpanded ? message : `${message.slice(0, 50)}...`}
              </span>
            </span>
            <span
              className="CalendarError__content--expand pt-2"
              onClick={() => setIsExpanded((prev) => !prev)}
            >
              {isExpanded ? "Hide" : "Expand"}
            </span>
          </div>
        </div>

        <div className="d-flex CalendarError__buttons">
          <Button
            color="outline-red"
            title="Re-authenticate"
            size="small"
            onClick={() => handleFixDirectoryButton(id)}
          />
          <Button
            color="simple"
            title="Read more"
            size="small"
            onClick={() => setOpenReAuthModal(true)}
          />
        </div>
      </div>
    </>
  );
};
